
export default {
  head: {
    htmlAttrs: {
      id: 'scroll-to-top',
    },
  },
}
